import { formatNumber } from '@/helpers/formatNumber';

const NumberCell = ({ number }: { number: number }) => formatNumber(number);

export default NumberCell;
